export default __webpack_public_path__ + "static/media/9ff7e0cee1348f3a7f9023f1c54ddac14952acd7.8195d313.png";